import { ErrorType } from './errorType';
import { type Condition, $$default, TokenType } from './grammar.type';
import * as GrammarUtil from './grammar.util';

function walk(i, arr, updateError): [number, Condition] {
    let index = i; let hyphen; let key; let value; let symbol;
    if (arr[index].type === TokenType.Hyphen) {
        hyphen = arr[index++].value;
    }
    key = arr[index].value;
    if (updateError &&
        arr[index].type !== TokenType.Alphabet &&
        arr[index].type !== TokenType.Chinese &&
        arr[index].type !== TokenType.String) {
        GrammarUtil.error({ type: ErrorType.ERROR_KEY_TYPE, value: key });
    }
    if (!arr[++index]) {
        return [index, { ...(hyphen ? { hyphen } : {}), key, symbol, value }];
    }
    if (arr[index].type !== TokenType.Symbol) {
        symbol = $$default;
        value = arr[index];
        return [index, { ...(hyphen ? { hyphen } : {}), key, symbol, value }];
    }
    symbol = arr[index].value;
    if (!arr[++index]) {
        return [index, { ...(hyphen ? { hyphen } : {}), key, symbol, value }];
    }
    value = arr[index];
    return [index, { ...(hyphen ? { hyphen } : {}), key, symbol, value }];
}

/**
 * * LUN Capacity>5 => [
 *      {type:string,value:LUN},
 *      {type:string,value:Capacity},
 *      {type:symbol,value:>}
 *      {type:number,value:5},
 * ] => {
 *     type:LUN,
 *     params:[
 *         {key:Capacity,Symbol:>,value:5}
 *     ]
 * }
 * @param tokens
 * @param updateError
 */
export function parse(tokens: any[], updateError = true): {
    type?: string;
    params?: Condition[];
} {
    if (!Array.isArray(tokens)) {
        throw new Error(`something maybe error in tokenizer，the tokens should be a array,but got ${typeof tokens}`);
    }
    const typeToken = tokens[0];
    const params = tokens.slice(1);
    const AST: { type?: string; params?: Condition[] } = { params: [] };
    AST.type = typeToken.value;
    for (let i = 0; i < params.length; i++) {
        let condition;
        [i, condition] = walk(i, params, updateError);
        AST.params.push(condition);
    }
    return AST;
}
